// Libs
import when from 'when'
import Emitter from 'event-emitter'
import glmat from 'gl-matrix'

// Strcutral
import SceneAbs from '../abstract/scene'
import Camera from '../utils/camera'
import TextureLoader from '../utils/textureLoaderObject'
import Manifest from '../manifest'

// Entities
import Background from '../entities/background'

// Post
import PostMarbling from '../postProcess/marblingDisplacement'

// Utils
import RAF from '@/js/utils/raf'
import DebugController from '@/glxp/debug/debugController'

const MARGIN_BOTTOM = 100
const SHAKE_DAMPING = 0.3
const SHAKE_CURSOR_DAMPING = 0.1
const SHAKE_STEP_DAMPING = 0.025
const SHAKE_THRESHOLD = 0.05

let mat4 = glmat.mat4
let vec3 = glmat.vec3
let vec2 = glmat.vec2

const _VEC2 = vec2.create()

var _emitter = {}
Emitter(_emitter)

class HeaderScene extends SceneAbs {
  constructor (container, manager = null) {
    super(container, manager)

    this.camera = new Camera(this, 30)
    this.camera.node.position[2] = -6
    this.shakeFactor = 0
    this.shakeFactorTarget = 0
    this.step = 0
    this.stepTarget = 0
    this.cursor = vec2.create()
    this.cursorTarget = vec2.create()
    this.lastCursor = vec2.create()
    this.velocity = vec2.create()
    this.marginBottom = MARGIN_BOTTOM * this.dpr

    this.clearColor = [1, 1, 1, 1]
    this.color = [0, 0, 0]
    this.useColor = false

    this.activeTexture = null

    this.mobile = false

    this.textureLoader = new TextureLoader(this)
    this.background = new Background(this)
    this.postMarbling = new PostMarbling(this)

    this.config = {
      shake_damping: { value: 0.3, range: [0, 0.1] },
      cursor_damping: { value: 0.1, range: [0, 0.1] },
      step_damping: { value: 0.02, range: [0, 0.1] },
      shake_threshold: { value: 0.05, range: [0, 1] }
    }

    DebugController.addConfig(this.config, 'HeaderScene')

    // this.initEvents()
  }

  onLoaded () {
    this.active = true
    this._emitter.emit('loaded')
  }

  start () {
    // this.shakeFactor = .05
  }

  initEvents () {
    this.container.addEventListener('mousemove', (event) => {
      this.cursorTarget[0] = event.clientX / ((this.width / this.dpr))
      this.cursorTarget[1] = event.clientY / ((this.height / this.dpr))
    })
  }

  loadColor (color) {
    this.color[0] = color[0]
    this.color[1] = color[1]
    this.color[2] = color[2]
    this.useColor = true
    this.load()
  }

  reset () {
    this.useColor = false
    this.active = false
    this.activeTexture = null
  }

  load (id, url) {
    let loadables = []

    for (const key in Manifest.header) {
      if (Manifest.header.hasOwnProperty(key)) {
        const element = Manifest.header[key].url
        loadables.push(this.textureLoader.load(element, key, Manifest.header[key].options))
      }
    }

    if (this.useColor == false) {
      this.activeTexture = id
      loadables.push(this.textureLoader.load(url, id, []))
    }

    when.all(loadables).then(() => {
      this.onLoaded()
    })

    let percent = 0
    for (let i = 0; i < loadables.length; i++) {
      loadables[i].then(() => {
        percent++
        this._emitter.emit('progress', Math.round((percent / loadables.length) * 100))
      })
    }
  }

  applyDefaultState () {
    let gl = this.gl
    gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA)
    gl.enable(gl.BLEND)
    gl.enable(gl.DEPTH_TEST)
    // gl.disable(gl.CULL_FACE)
  }

  // Pre-render
  preRender () {
    let gl = this.gl

    this.velocity[0] = Math.abs(this.cursorTarget[0] - this.lastCursor[0]) > 0.1 ? 0 : this.cursorTarget[0] - this.lastCursor[0]
    this.velocity[1] = Math.abs(this.cursorTarget[1] - this.lastCursor[1]) > 0.1 ? 0 : this.cursorTarget[1] - this.lastCursor[1]
    this.lastCursor[0] = this.cursorTarget[0]
    this.lastCursor[1] = this.cursorTarget[1]
    vec2.sub(_VEC2, this.cursorTarget, this.cursor)
    vec2.scale(_VEC2, _VEC2, SHAKE_CURSOR_DAMPING)
    vec2.add(this.cursor, this.cursor, _VEC2)
    this.camera.updateProjection(this.width / this.height)
    this.shakeFactorTarget = Math.max(vec2.length(this.velocity), 0.03)
    let tmp = this.shakeFactorTarget - this.shakeFactor
    tmp *= SHAKE_DAMPING
    this.shakeFactor += tmp

    // if (this.shakeFactor > SHAKE_THRESHOLD) {
    //     this.stepTarget = 1
    // } else {
    //     this.stepTarget = 0
    // }
    // tmp = this.stepTarget - this.step
    // tmp *= SHAKE_STEP_DAMPING
    // this.step += tmp
  }

  // Render
  render () {
    if (!this.active) { return }
    this.time += RAF.dt / 1000
    this.dt = RAF.dt

    let gl = this.gl

    gl.clearColor(this.clearColor[0], this.clearColor[1], this.clearColor[2], this.clearColor[3])
    gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT)
    gl.colorMask(true, true, true, true)

    this.preRender()
    gl.viewport(0, 0, this.width, this.height)

    // Render Time

    if (!this.mobile) {
      this.postMarbling.preRender()
      this.background.render()
      this.postMarbling.postRender()

      this.postMarbling.render()
    } else {
      this.background.render()
    }

    this.postRender()
  }

  getCanvas () {

  }

  postRender () {
    this.gl.viewport(0, 0, this.width, this.height)
    // this.grain.render()
  }
}
export default HeaderScene
